//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';

export default {
    state: {
        importLoadList: [],
        searchRequest: null,
      },

      mutations: {
        updateImportLoadList(state, list) {
          state.importLoadList = list;
        },
        updateSearchImportLoadListRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },


      actions: {
        async importLoadList({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));

          // if (requestToSend.apptDate.endDate) {
          //   requestToSend.apptDate.endDate = moment(requestToSend.apptDate.endDate)
          //     .endOf('d')
          //     .toDate();
          // }
        
          // if (requestToSend.apptDate.startDate && !requestToSend.apptDate.endDate) {
          //   requestToSend.apptDate.endDate = moment(requestToSend.apptDate.startDate)
          //     .endOf('d')
          //     .toDate();
          // }

          // if (requestToSend.pickupDate.endDate) {
          //   requestToSend.pickupDate.endDate = moment(requestToSend.pickupDate.endDate)
          //     .endOf('d')
          //     .toDate();
          // }
        
          // if (requestToSend.pickupDate.startDate && !requestToSend.pickupDate.endDate) {
          //   requestToSend.pickupDate.endDate = moment(requestToSend.pickupDate.startDate)
          //     .endOf('d')
          //     .toDate();
          // }


          if (requestToSend.apptDate.startDate)
          {
            requestToSend.apptDate.startDate = dateFormat.getLocalDate(requestToSend.apptDate.startDate);
          }

          if (requestToSend.apptDate.endDate)
          {
            requestToSend.apptDate.endDate = dateFormat.getLocalDateEnd(requestToSend.apptDate.endDate);
          }
          else
          {
            requestToSend.apptDate.endDate = dateFormat.getLocalDateEnd(requestToSend.apptDate.startDate);
          }


          if (requestToSend.pickupDate.startDate)
          {
            requestToSend.pickupDate.startDate = dateFormat.getLocalDate(requestToSend.pickupDate.startDate);
          }

          if (requestToSend.pickupDate.endDate)
          {
            requestToSend.pickupDate.endDate = dateFormat.getLocalDateEnd(requestToSend.pickupDate.endDate);
          }
          else
          {
            requestToSend.pickupDate.endDate = dateFormat.getLocalDateEnd(requestToSend.pickupDate.startDate);
          }





            const st = performance.now();
            //const result = await api.post('/api/w/gst/WebSearchDispatchList', requestToSend);
            const result = await newAPIPost('/api/w/gst/WebSearchDispatchList', requestToSend);
            commit('updateSearchImportLoadListRequest', fallbackRequest);
            console.log(result);
            return commit('updateImportLoadList', result);
            
                },
      },


      getters: {
        getImportLoadList: state => state.importLoadList,
      },








}